import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

import styles from './style.module.scss'

const cx = classnames.bind(styles)

const VipOnlyMask = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className={cx('vip-only__mask')} />
      <div className={cx('vip-only__text')}>{t('Common_VIP_Only')}</div>
    </>
  )
}

export default VipOnlyMask
